<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            :isShowEditButton="false"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <span>{{ data?.before.payKind }}</span>
                    </template>
                    <template #after>
                        <span>{{ data?.after.payKind }}</span>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'D1Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('D1');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, removeService };
    },
};
</script>
